<script setup lang="ts">
    import { computed, watch, onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import { useCurrentUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useResetPasswordCommandV1, useSignoutFromSessionCommandV1, useSignoutFromAllSessionsCommandV1 } from '@Organizations/Users/commands-vue-composables'

    const router = useRouter()
    const goBack = () => router.back()

    const {
        runCurrentUserQueryV1,
        modelCurrentUserQueryV1: userSessionDetails
    } = useCurrentUserQueryV1(false, false, false)

    const userId = computed(() => userSessionDetails.value?.UserId)
    const currentSessionId = computed(() => userSessionDetails.value?.CurrentSessionId)

    const { invokeResetPasswordCommandV1 } = useResetPasswordCommandV1(userId);
    const { invokeSignoutFromSessionCommandV1, onSucceedSignoutFromSessionCommandV1 } = useSignoutFromSessionCommandV1(userId, currentSessionId);
    const { invokeSignoutFromAllSessionsCommandV1, onSucceedSignoutFromAllSessionsCommandV1 } = useSignoutFromAllSessionsCommandV1(userId);


    onSucceedSignoutFromSessionCommandV1(() =>
    {
        location.href = '/#/signin'
    })

    onSucceedSignoutFromAllSessionsCommandV1(() =>
    {
        location.href = '/#/signin'
    })


    onMounted(() =>
    {
        document.title = 'TransparentChoice account'
        runCurrentUserQueryV1()
    })

    watch(userSessionDetails, (details) =>
    {
        if (!details) return

        if (details.UserId === 0)
        {
            router.push('/')
        }
    })

    function handleResetPassword()
    {
        if (confirm('Do you really want to reset your password?'))
        {
            invokeResetPasswordCommandV1()
        }
    }
</script>


<template>
    <div>
        <button @click="goBack" type="button" class="btn btn-lg btn-link">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
            Back
        </button>

        <div style="min-width: 400px; width: 40vw; margin: auto; margin-top: 40px;">
            <h2 class="fg-color-blue">{{userSessionDetails?.DisplayName}}</h2>

            <div>
                <span>Organization: </span>
                <strong v-if="userSessionDetails?.OrganizationUnitId" class="fg-color-gray">
                    {{userSessionDetails?.OrganizationUnitName}}
                </strong>
                <strong v-else-if="userSessionDetails?.IsGlobalAdmin">
                    <a :href="`/#/admin/organizations/users/manage/organization/${userSessionDetails.UserId}`">None</a>
                </strong>
                <strong v-else>None</strong>
            </div>

            <div>
                <span>Email: </span>
                <strong class="fg-color-gray">{{userSessionDetails?.Email}}</strong>
            </div>

            <hr /><br />

            <div class="border-box">
                <h4>My password</h4>
                <p style="font-size: 16px;">You can change password by providing your one or reset it to let us generate one for you and send it to your email</p>
                <a type="button" class="btn btn-primary mr-2" href="/#/organizations/users/changepassword">Change password</a>
                <button type="button" class="btn btn-secondary" @click="handleResetPassword">Reset password</button>
            </div>

            <div class="border-box">
                <h4>My sign-ins</h4>
                <p style="font-size: 16px;">Do you want do sign-out just from the current session or also from all other sessions on all other devices and browsers?</p>
                <button type="button" class="btn btn-primary mr-2" @click="invokeSignoutFromSessionCommandV1">Current session</button>
                <button type="button" class="btn btn-secondary" @click="invokeSignoutFromAllSessionsCommandV1">All my sessions</button>
            </div>

            <div class="border-box">
                <h4>Access tokens</h4>
                <p style="font-size: 16px;">Manage your tokens for  API calls</p>
                <a role="button" class="btn btn-primary" href="/#/organizations/accesstokens/my">My tokens</a>
            </div>
        </div>
    </div>
</template>